import Service from "./Service";

class TrainStationApiService extends Service {
  constructor() {
    super("api/TrainStations");
  }

  async getAll() {
    let result = await this.get(``, (status, data) => {
      return data;
    });
    return result;
  }

  async getDepartureTimeList(departureStationId, arrivalStationId, trainId, departureDate) {
    let result = await this.get(
      `/GetDepartureTimeList?departureStationId=${departureStationId}&arrivalStationId=${arrivalStationId}&departureDate=${departureDate}`,
      (status, data) => {
        return data;
      }
    );
    return result;
  }

  async getDistance(departureStationId, arrivalStationId, departureDate) {
    let result = await this.get(
      `/GetDistance?departureStationId=${departureStationId}&arrivalStationId=${arrivalStationId}&departureDate=${departureDate}`,
      (status, data) => {
        return data;
      }
    );
    return result;
  }
}

export default new TrainStationApiService();
